import { useEffect, useMemo, useState } from 'react';
import {
  countExplorePickups,
  subscribeExploreDrops,
} from '../../../services/exploreDrops';
import {
  exploredSarajevoPercent,
  fogRevealCellsFromProfile,
} from '../../../services/fogReveal';
import {
  explorePointsFromProfile,
  formatExplorePointsLabel,
} from '../../../services/explorePoints';

function padStat(n) {
  const v = Math.max(0, Math.floor(Number(n) || 0));
  return v < 10 ? `0${v}` : String(v);
}

function formatExploredPercent(pct) {
  if (!Number.isFinite(pct) || pct <= 0) return '0%';
  if (pct < 0.1) return '<0.1%';
  if (pct < 10) return `${pct.toFixed(1)}%`;
  return `${Math.round(pct)}%`;
}

/**
 * Compact Game-subnav stats from profile fog + live drops list.
 */
export default function useGameNavStats({ uid, userProfile, enabled }) {
  const [drops, setDrops] = useState([]);

  useEffect(() => {
    if (!enabled || !uid) {
      setDrops([]);
      return undefined;
    }
    return subscribeExploreDrops(setDrops, (err) => {
      console.error('explore nav stats drops subscribe failed:', err);
    });
  }, [enabled, uid]);

  return useMemo(() => {
    if (!enabled || !uid) {
      return {
        exploredLabel: '0%',
        pointsLabel: '00',
        dropsFound: 0,
        dropsTotal: 0,
        dropsCreated: 0,
        dropsStillOut: 0,
        dropsFoundLabel: '00 / 00',
        dropsCreatedLabel: '00',
      };
    }

    const cells = fogRevealCellsFromProfile(userProfile);
    const exploredLabel = formatExploredPercent(exploredSarajevoPercent(cells));
    const pointsLabel = formatExplorePointsLabel(
      explorePointsFromProfile(userProfile)
    );
    const dropsFound = countExplorePickups(userProfile);
    const dropsFindable = drops.filter((d) => d.authorUid && d.authorUid !== uid).length;
    const dropsCreated = drops.filter((d) => d.authorUid === uid).length;
    const dropsTotal = Math.max(dropsFindable, dropsFound);
    const dropsStillOut = Math.max(0, dropsTotal - dropsFound);

    return {
      exploredLabel,
      pointsLabel,
      dropsFound,
      dropsTotal,
      dropsCreated,
      dropsStillOut,
      dropsFoundLabel: `${padStat(dropsFound)} / ${padStat(dropsTotal)}`,
      dropsCreatedLabel: padStat(dropsCreated),
    };
  }, [enabled, uid, userProfile, drops]);
}
